import type { AllFlagInstructionKinds, SemanticInstruction, SemanticInstructionForKind } from './types';

// isInstructionOfKind is a type guard that returns true if the given instruction has the specific kind.
export function isInstructionOfKind<K extends AllFlagInstructionKinds>(
  ins: SemanticInstruction,
  kind: K,
): ins is SemanticInstructionForKind<K> {
  return ins.kind === kind;
}
